// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2454":"bad16166","2941":"911dc3c4","3327":"bad16166","6037":"b1e85869","7789":"911dc3c4"}[chunkId] + ".chunk.css";
};